<template>
  <o-form-group
    :form-state="formState"
    :label="label"
    :message="errorMessages"
    :nolabel="nolabel"
    :id="this_id"
    :type="{ 'is-danger': hasError }"
  >
    <b-input-group>
      <b-form-input
        :placeholder="checkSearchType ? 'Search: Job ID' : ''"
        :type="checkSearchType ? 'number' : 'text'"
        :class="input_class"
        :readonly="isInputReadonly"
        v-bind="$attrs"
        v-bind:value="value"
        v-on="inputListeners"
        v-model="searchKeyword"
        @input="disableButton"
        @keyup.enter.native.prevent="searchJob"
      >
      </b-form-input>
      <b-button v-if="showSearchButton" @click="searchJob">Search</b-button>
      <b-button v-if="showXButton" @click="editInput">X</b-button>
    </b-input-group>

    <table v-if="showTable" class="table table-bordered table-condensed">
      <tr>
        <th>Job Number</th>
        <th>Address</th>
        <th>Customer</th>
        <th>Supervisor</th>
      </tr>
      <tr v-for="jobItem in items">
        <td>{{ jobItem.id || jobItem.original_job_number }}</td>
        <td>{{ jobItem.site_address }}, {{ jobItem.suburb }}</td>
        <td>
          <lookup-display
            :list="optionCustomerItemsById"
            :value="jobItem.customer"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </td>
        <td>
          <lookup-display
            :list="optionSupervisorItemsById"
            :value="jobItem.supervisor"
            display-field="name"
            default-value="-"
          ></lookup-display>
        </td>
        <td>
          <button class="btn btn-primary" @click="select(jobItem)">
            SELECT
          </button>
        </td>
      </tr>
    </table>

    <span v-if="formState.debug">
      SE:{{ serverErrors }} [{{ serverErrorsIndex }}].{{ name }}<br />
      AL_SE:{{ all_server_errors }}
    </span>
  </o-form-group>
</template>

<script>
import FormComponentMixin from "../../../vue-ocom/mixins/form_component_mixin";
import OFormGroup from "../../../vue-ocom/components/forms/OFormGroup";
import { CreateCodeTableFetchMixin } from "../../../vue-ocom/mixins";
import Swal from "sweetalert2";

export default {
  name: "JobSearch",
  components: { OFormGroup },
  mixins: [
    FormComponentMixin,
    CreateCodeTableFetchMixin(["Customer", "Supervisor"]),
  ],
  props: {
    jobItem: { type: Object, default: () => {} },
    create: Boolean,
    job_number: null,
    address: String,
    suburb: String,
    isMaterialAndSupply: { type: Boolean, default: false },
    filter: { type: String, default: "" },
  },
  computed: {
    checkSearchType() {
      if (this.filter != "") {
        return true;
      }

      return false;
    },
  },
  data() {
    return {
      isCreateForm: this.create,

      isInputReadonly: false,
      searchKeyword: "",

      showSearchButton: true,
      showXButton: false,

      items: [],
      showTable: false,
    };
  },
  methods: {
    disableButton() {
      this.formState.dirty = false;
      this.formState.invalid = true;
    },
    enableButton() {
      this.formState.dirty = true;
      this.formState.invalid = false;
    },
    searchJob() {
      this.disableButton();
      var list_options = {
        limit: 51,
        offset: 0,
        q: this.searchKeyword,
        filter: this.filter,
        _code: false,
      };
      this.$store.dispatch("JobModule/getAll", list_options).then(() => {
        this.items = this.$store.getters["JobModule/items"];

        if (this.items.length > 50) {
          this.over50JobResults();
        }
        if (this.items.length < 1) {
          this.noJobResults();
        }

        this.showTable = true;
      });
    },
    editInput() {
      this.isCreateForm = true;
      this.isInputReadonly = false;
      this.showXButton = false;
      this.showSearchButton = true;
    },
    getCustomerName(customer) {
      return this.optionCustomerItemsById[customer]["name"];
    },
    getSupervisorName(supervisor) {
      return this.optionSupervisorItemsById[supervisor]["name"];
    },
    select(jobItem) {
      this.enableButton();
      this.searchKeyword = this.checkSearchType
        ? jobItem.id
        : (jobItem.id || jobItem.original_job_number) +
          ": " +
          jobItem.site_address +
          ", " +
          jobItem.suburb;
      this.$emit("update-job", jobItem);

      this.showTable = false;
      this.isInputReadonly = true;
      this.showSearchButton = false;
      this.showXButton = true;
    },
    over50JobResults() {
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Jobs Found!",
        text:
          "We found over 50 jobs matching your criteria, try being more specific.",
        showConfirmButton: true,
      });
    },
    noJobResults() {
      Swal.fire({
        position: "center",
        icon: "error",
        title: "No Jobs Found",
        text:
          'No jobs found match the text "' +
          this.searchKeyword +
          '". Please try again. Try to be less specific ie search by Street name',
      });
    },
  },
  watch: {
    jobItem(newVal, oldVal) {
      if (newVal) {
        this.select(newVal);
      }
    },
  },
  updated() {
    if (this.isCreateForm == false) {
      if (this.isMaterialAndSupply) {
      }
      this.searchKeyword = this.checkSearchType
        ? this.job_number
        : this.job_number + ": " + this.address + ", " + this.suburb;
      this.isInputReadonly = true;
      this.showSearchButton = false;
      this.showXButton = true;
    }
  },
};
</script>

<style scoped></style>
